/**
 * The pieces every AI report is drawn with: the icon and colour of each
 * severity, and the inline markdown renderer.
 *
 * Shared by the live console (MedicalAiAnalyzer) and the stored summaries
 * (AiSummaryCard), so a report reads the same whether it was streamed to the
 * doctor a second ago or prepared by the secretary this morning.
 */

export const TONE_ICON = {
  critical: 'alert-triangle',
  warning: 'alert-circle',
  minor: 'info',
  gap: 'help-circle',
  action: 'check-circle-2',
  summary: 'stethoscope',
  notice: 'alert-triangle',
  neutral: 'circle',
};

export const TONE_TEXT = {
  critical: 'text-red-300',
  warning: 'text-orange-300',
  minor: 'text-yellow-300',
  gap: 'text-sky-300',
  action: 'text-emerald-300',
  summary: 'text-purple-200',
  notice: 'text-amber-300',
  neutral: 'text-slate-300',
};

/**
 * Inline markdown, rendered.
 *
 * The prompt's own template uses `**الخلاصة:**`, so a renderer that ignores it
 * shows the asterisks to the doctor. Two forms only — bold and code — because
 * that is all a ten-line report ever contains.
 */
export function Inline({ segments, text }) {
  const parts = segments || (text ? [{ text, bold: false, code: false }] : []);

  return (
    <>
      {parts.map((segment, index) => {
        if (segment.bold) {
          return (
            <strong key={index} className="font-black">
              {segment.text}
            </strong>
          );
        }
        if (segment.code) {
          return (
            <code key={index} className="rounded border border-white/10 bg-white/10 px-1 py-px font-mono text-[0.9em]">
              {segment.text}
            </code>
          );
        }
        return <span key={index}>{segment.text}</span>;
      })}
    </>
  );
}
